import holidaysData from '../assets/data/holidays.json';

// 祝日データの型定義
interface Holiday {
  date: string;
  name: string;
}

interface HolidaysMap {
  [year: string]: Holiday[];
}

// 祝日データを日付をキーにしたマップに変換
const createHolidayMap = (): Map<string, string> => {
  const map = new Map<string, string>();
  const typedHolidays = holidaysData as HolidaysMap;
  
  // すべての年のデータを1つのマップにまとめる
  Object.values(typedHolidays).forEach(yearHolidays => {
    yearHolidays.forEach(holiday => {
      map.set(holiday.date, holiday.name);
    });
  });
  
  return map;
};

// 祝日マップをキャッシュ
const holidayMap = createHolidayMap();

/**
 * 指定された日付が祝日かどうかを判定し、祝日であれば名前を返す
 * @param dateStr YYYY-MM-DD形式の日付文字列
 * @returns 祝日の名前。祝日でない場合はnull
 */
export const getHolidayName = (dateStr: string): string | null => {
  return holidayMap.get(dateStr) || null;
};

/**
 * 指定された日付が祝日かどうかを判定
 * @param dateStr YYYY-MM-DD形式の日付文字列
 * @returns 祝日であればtrue、そうでなければfalse
 */
export const isHoliday = (dateStr: string): boolean => {
  return holidayMap.has(dateStr);
};
